import LanguagMenu from './LanguageMenuContainer';

export default LanguagMenu;
